
// 使用sha256替换crypto-js提供的HmacSha256加密算法
import HmacSHA256 from 'crypto-js/hmac-sha256'
import Utf8 from "crypto-js/enc-utf8"
import Hex from "crypto-js/enc-hex"

const expiration = 1800; // 单位是s，有效时间

const Sha256HMAC = (privateKey, ts) => {
    const key = Utf8.parse(privateKey)
    const timestamp = Utf8.parse(ts)
    const hmac = Hex.stringify(HmacSHA256(timestamp, key))
    return hmac;
}

function hash(ver, ak, sk, data) {
    try {
        const timestamp = (+new Date() / 1000).toFixed(0);
        const signKeyInfo = `${ver}/${ak}/${timestamp}/${expiration}`;
        const signKey = Sha256HMAC(sk, signKeyInfo);
        const signResult = Sha256HMAC(signKey, data);
        return signKeyInfo + '/' +signResult;
    } catch(err) {
        return ''
    }
}

export default hash;